export enum QuestionType {
  TextEntrySingleLine = 'TESL',
  TextEntryMultiLine = 'TEML',
  MultiChoiceSingleAnswer = 'MCSA',
  MultiChoiceMultiAnswer = 'MCMA'
}

export enum ResponseType {
  TESL = '_TEXT',
  TEML = '_TEXT',
  MCSA = '',
  MCMA = ''
}

export enum DisplayOperator {
  Selected = 'Selected',
  NotSelected = 'NotSelected'
}

export enum DisplayConjuction {
  AND = 'And',
  OR = 'Or'
}

export enum SkipCondition {
  Selected = 'Selected'
}

export enum SkipEndpoint {
  EndOfBlock = 'ENDOFBLOCK',
  EndOfSurvey = 'ENDOFSURVEY'
}

export enum SurveyErrorCode {
  UnsupportedDisplayConjuction = 501,
  UnsupportedDisplayOperator = 502,
  UnsupportedQuestionType = 503,
  UnsupportedSkipCondition = 504
}

export enum SurveyErrorMessage {
  UnsupportedDisplayConjuction = 'Display conjuction not supported',
  UnsupportedDisplayOperator = 'Display operator not supported',
  UnsupportedQuestionType = 'Question type not supported',
  UnsupportedSkipCondition = 'Skip condition not supported'
}
